import React from "react";
import Card from "./Card";
import { Product } from "../../graphql/fragments/product";
import { QueryResultProps } from "../../types/shared";
import { Text, Stack } from "@chakra-ui/react";
import { Waypoint } from "react-waypoint";

interface ProductListProps extends QueryResultProps {
  onWaypointReached: () => void;
  products: Product[] | undefined;
}

const noop = () => undefined;

const ProductList: React.FC<ProductListProps> = (props) => {
  const { products, onWaypointReached = noop } = props;

  const globalWindow = typeof window !== "undefined" ? window : null;

  if (products?.length) {
    return (
      <Stack spacing={3}>
        {products.map((product, i) => (
          <React.Fragment key={product.id}>
            <Card product={product} />
            {i === products.length - 10 && (
              <Waypoint
                scrollableAncestor={globalWindow}
                onEnter={() => onWaypointReached()}
              />
            )}
          </React.Fragment>
        ))}
      </Stack>
    );
  }
  return <Text>No products found...</Text>;
};

export default ProductList;
